import { Component, DestroyRef, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService, UserService } from './_services';
import { AuthResponse } from './_models/responses';
import { faArrowLeft, faBell, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Role } from './_models/role';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Notifications } from './_models/notification.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'entrarit-web';
  currentYear: number = new Date().getFullYear();

  public isMenuCollapsed = true;
        currentUser: AuthResponse | null = null;
    messages: any | undefined;
    VNUM: string | undefined;
    faArrowLeft = faArrowLeft;
    faBell = faBell;
    faArrowRightFromBracket = faArrowRightFromBracket;
    Approval!: number;
    propNotifs: Notifications[] = [];
    private destroyRef = inject(DestroyRef);
    // private messaging: firebase.messaging.Messaging;

    // message;
    constructor(
        //@Inject(FirebaseApp) private _firebaseApp: firebase.app.App,
        private router: Router,
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private toastr: ToastrService,
        //private afMessaging: AngularFireMessaging,
        private _location: Location
    ) {
        // Keep constructor side-effect free to avoid early change detection churn.
    }

    viewNotifications(propertyid: number) {
        this.router.navigate(['/access-management/'+propertyid])
    }

    checkNotifications() {
        // this.afMessaging.messages
        //     .subscribe((message) => {
        //         console.log('Notification: ',message);
        //         if (message) {
        //             alert(message);
        //         }
        //     });
    }

    isAdmin() {
        //return this.currentUser;
        if (this.currentUser) {
            if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
                return this.currentUser.role.includes(Role.ROLE_ADMIN);
            }

        }
        return false;
    }

    isSuper() {
        if (this.currentUser) {
            if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
                return this.currentUser.role.includes(Role.ROLE_SUPER);
            }

        }
        return false;
    }

    goBack() {
        this._location.back();
    }

    openNumberManagement() {
        this.router.navigate(['/available-properties/manage-numbers'])
    }

    openAccessManagement() {
        this.router.navigate(['/available-properties/manage']);
    }

    openAccessLog() {
      this.router.navigate(['/available-properties/log']);
    }



    ngOnInit() {
        // this.afMessaging.messages
        // .subscribe((message) => {
        //     this.messages = message;
        // });
        this.VNUM = environment.appVersion

        this.authenticationService.currentUser
            ?.pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (user) => {
                    this.currentUser = user;
                    this.loadAdminNotifications();
                }
            });

        this.loadAdminNotifications();

        //this.VNUM = environment.VNUM;
        console.log('Version: ', environment.appVersion);
    }

    private loadAdminNotifications() {
        if (!this.isAdmin()) {
            return;
        }

        this.userService.getPropertiesByRoleAccessList(this.currentUser!.username || '', 'ROLE_ADMIN')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (data) => {
                    this.propNotifs = [];
                    data.forEach((element) => {
                        this.userService.getRequestAccessList(element.id!)
                            .pipe(takeUntilDestroyed(this.destroyRef))
                            .subscribe({
                                next: (reqdata) => {
                                    const approvals = reqdata.filter((request) => {
                                        return request.approved == false || request.approved == null;
                                    }).length;

                                    const notif: Notifications = { propid: element.id, notifications: approvals };

                                    if (approvals > 0) {
                                        this.propNotifs.push(notif);
                                    }


                                },
                                error: (error) => {
                                    console.log('Request access error', error);
                                }
                            });
                    });
                },
                error: () => {
                    this.toastr.error('Fail to retrieve properties.', 'Error');
                }
            });

        if (!environment.production) {
            console.log('Fetching properties that user can manage');
        }
    }

    noBackButton() {
      return this.router.url == '/' || this.router.url.includes('/login') || this.router.url == '/change-password' || this.router.url == '/visitor/create' || this.router.url == '/kiosk-access';
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }
}
